export default __webpack_public_path__ + "static/media/youtube-hero.f9adb3e0.svg";